import React, { useState } from "react";
import styles from "./chat-attachment-image.module.css";

const ChatAttachmentImage = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={styles["chat-attachment-img-wrapper"]}>
      {!loaded && <div className={styles["chat-img-loader"]} />}
      <img
        src={src}
        alt={alt}
        className={`${styles["chat-attachment-img"]} ${styles[loaded ? "visible" : "hidden"]}`}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default ChatAttachmentImage;
